// extracted by mini-css-extract-plugin
var _1 = "TableModalSelectionToolbar-moduleTableModalSelectionToolbar__Odooo";
var _2 = "TableModalSelectionToolbar-moduleshadow__Dl4zL";
export { _1 as "TableModalSelectionToolbar", _2 as "shadow" }
